import { render } from "./Carrousel.vue?vue&type=template&id=55b67de5&scoped=true"
import script from "./Carrousel.vue?vue&type=script&lang=js"
export * from "./Carrousel.vue?vue&type=script&lang=js"

import "./Carrousel.vue?vue&type=style&index=0&id=55b67de5&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55b67de5"]])

export default __exports__